var map = {
	"./coastal-1.jpg": 40460,
	"./coastal-10.jpg": 62442,
	"./coastal-12.jpg": 13326,
	"./coastal-13.jpg": 58635,
	"./coastal-2.jpg": 38270,
	"./coastal-4.jpg": 94631,
	"./coastal-5.jpg": 69167,
	"./coastal-6.jpg": 5979,
	"./coastal-7.jpg": 71170,
	"./coastal-8.jpg": 83483,
	"./coastal-9.jpg": 33385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58976;